import { create } from "zustand";

const useStore = create((set) => ({
  slide: 0,
  currentSlide: (newSlide) => set({ slide: newSlide }),
}));

export default useStore;
